import React, { useCallback, useEffect } from 'react';
import { useNavigation, useNavigationType, useParams } from 'react-router-dom';
import {
  clearAccount,
  getBalances,
  getById,
  getDaily
} from '../../../features/client/client.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useBanner } from '../../../hooks/bannerProvider';
import { useTitle } from '../../../hooks/titleProvider';
import { Box } from '@mui/system';
import Overview from '../../account/balancesView/components/overview';
import Products from '../../account/balancesView/components/products';
// import DailyAccount from '../../account/balancesView/components/dailyAccount';
import OrangeCircularProgress from '../../ui/controls/circularProgress';
import { AccessMap, UserFunctions, hasAccess } from '../../../helpers/access';
import ClientUpdate from './clientUpdate';
import { Typography } from '@mui/material';
import ClientReports from './clientReports';
import {
  brokerClientGetBalances,
  brokerClientGetById
} from '../../../features/broker/broker.slice';

const BrokerHouseClientAccounts = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const user = useSelector((state) => state.auth.user);
  const client = useSelector((state) => state.broker.client);
  const account = useSelector((state) => state.broker.account);
  const loadingBalances = useSelector((state) => state.broker.loadingBalances);
  const navigationType = useNavigationType();

  const { setTitle } = useTitle();
  const { setBanner } = useBanner();

  useEffect(() => {
    setBanner(null);
  }, [setBanner]);

  useEffect(() => {
    if (!client) {
      dispatch(brokerClientGetById(id));
    }

    return () => {
      setTitle('');
    };
  }, [id, dispatch, navigationType]);

  const memoizedSetTitle = useCallback(
    (title) => {
      setTitle(title);
    },
    [setTitle]
  );

  useEffect(() => {
    if (client) {
      if (client.firstName || client.entityName) {
        memoizedSetTitle(
          (client.firstName ? client.firstName : client.entityName || '') +
            ' ' +
            (client.lastName ?? '') || ''
        );
      } else if (client.idNumber) {
        memoizedSetTitle(client.idNumber);
      } else {
        memoizedSetTitle('Client');
      }
    }
  }, [client, memoizedSetTitle]);

  useEffect(() => {
    if (client) {
      dispatch(brokerClientGetBalances(client._id));
    }

    return () => {};
  }, [client, dispatch, id]);

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
      {!loadingBalances && account ? (
        <Box width={'100%'} maxWidth={'700px'}>
          {/* <Overview account={account} title={`Fairtree`} /> */}
          <Box display="flex" justifyContent={'flex-end'} alignSelf={'flex-end'} gap={2}>
            {client && hasAccess(user, UserFunctions.ClientsAdmin, AccessMap.Update) ? (
              <ClientUpdate clientId={client.idNumber} />
            ) : null}

            {client && hasAccess(user, UserFunctions.ClientsAdmin, AccessMap.Read) ? (
              <ClientReports client={client} />
            ) : null}
          </Box>

          <Products account={account} broker={true} />
        </Box>
      ) : (
        <OrangeCircularProgress caption="Fetching your profile summary." />
      )}
    </Box>
  );
};

export default BrokerHouseClientAccounts;
